const STORAGE_KEY = 'mestti-manual-last-topic';

export const MANUAL_DEFAULT_TOPIC = 'integracao_ordens_processos';

export const MANUAL_TOPIC_IDS = [
  'integracao_ordens_processos',
  'configuracao_sensor',
  'treinamentos',
] as const;

export type ManualTopicId = (typeof MANUAL_TOPIC_IDS)[number];

export function isValidManualTopic(topic: string | null | undefined): topic is ManualTopicId {
  return !!topic && (MANUAL_TOPIC_IDS as readonly string[]).includes(topic);
}

export function getSavedManualTopic(): ManualTopicId {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    return isValidManualTopic(saved) ? saved : MANUAL_DEFAULT_TOPIC;
  } catch {
    return MANUAL_DEFAULT_TOPIC;
  }
}

export function saveManualTopic(topic: string): void {
  if (!isValidManualTopic(topic)) return;
  try {
    localStorage.setItem(STORAGE_KEY, topic);
  } catch {
    // ignore quota / private mode
  }
}

export function resolveManualTopicFromSearch(search: string): ManualTopicId | null {
  const topic = new URLSearchParams(search).get('topic');
  return isValidManualTopic(topic) ? topic : null;
}

export function buildManualPath(topic?: string): string {
  const resolved = isValidManualTopic(topic) ? topic : getSavedManualTopic();
  return `/manual?topic=${encodeURIComponent(resolved)}`;
}
